import React from 'react';

import { IconProps, SvgIcon } from './SvgIcon';

export const Receipt = (props: IconProps = {}): JSX.Element => {
  const { ...rest } = props;

  return (
    <SvgIcon name="Receipt" {...rest}>
      <path
        d="M18 2.5L18.8 3.1L20 4V20L18.8 20.9L18 21.5L17.2 20.9L16 20L14.8 20.9L14 21.5L13.2 20.9L12 20L10.8 20.9L10 21.5L9.2 20.9L8 20L6.8 20.9L6 21.5L5.2 20.9L4 20V4L5.2 3.1L6 2.5L6.8 3.1L8 4L9.2 3.1L10 2.5L10.8 3.1L12 4L13.2 3.1L14 2.5L14.8 3.1L16 4L17.2 3.1L18 2.5ZM22 0L20 1.5L18 0L16 1.5L14 0L12 1.5L10 0L8 1.5L6 0L4 1.5L2 0V24L4 22.5L6 24L8 22.5L10 24L12 22.5L14 24L16 22.5L18 24L20 22.5L22 24V0Z"
        fill="currentColor"
      />
      <path
        d="M6 8H13"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M15 8H18"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M6 12H13"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M15 12H18"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M6 16H13"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M15 16H18"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </SvgIcon>
  );
};
